<template>
  <div class="entry-wrapper">

    <!-- 上传照片入口 -->
    <div class="entry-box">

      <!-- 上传图片 input -->
      <input class="up-img-input" v-show="false" type="file"  ref="upImgInput" accept="image/*" @change="upImgChangeFunc()">

      <!-- 本地上传 按钮 -->
      <div class="entry-btn" data-growing-container @click="upImgTriggerFunc()">
        <img class="entry-btn-icon" src="https://files.wondercv.com/pc-vue/editor/portrait/up-img-icon-1.png" alt="">
        <div class="entry-btn-desc">
          <h4>上传本地照片</h4>
          <p>支持 jpg、png、bmp格式</p>
        </div>
      </div>

      <!-- 制作证件照 按钮 -->
      <div class="entry-btn" data-growing-container @click="upPhoneImgTriggerFunc()">
        <img class="entry-btn-icon" src="https://files.wondercv.com/pc-vue/editor/portrait/up-img-icon-2.png" alt="">
        <div class="entry-btn-desc">
          <h4>制作证件照</h4>
          <p>一键换装、自然美颜</p>
        </div>
      </div>

    </div>

    <!-- 折叠面板 -->
    <div class="entry-collapse">
      <el-collapse v-model="collapseIndex" :accordion="true"  @change="collapseChangeFunc">
        <el-collapse-item :title="item.title" :name="index" v-for="(item, index) in collapseMap" :key="index">
          <div v-html="item.description"></div>
        </el-collapse-item>
      </el-collapse>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      collapseIndex: 2, // 折叠面板活跃索引
      collapseMap: [
				{
					title: '简历上是否应该放照片？',
					description: '基本上遵守两个规则：<br/>1. 民企/国企推荐放照片，外企推荐不放照片<br/>2. 中文简历推荐放照片，英文简历推荐不放照片<br/>如果决定放照片，一定要使用证件照/职业照，一定不要用生活照'
				},
				{
					title: '简历上的照片应该是什么样的？',
					description: '对于简历照片，我们推荐如下格式：<br/>1. 剪裁：头部上方空一定距离，下面要露到肩膀左右，不要剪裁成大头照<br/>2. 底色：白色、蓝色或灰色，红色一般不推荐（像结婚照）<br/>3. 发型：长发盘起来；短发梳好，尽可能不要遮挡脸部；避免头发凌乱<br/>4. 表情：微笑即可，不要特别严肃也不要大笑<br/>5. 着装：申请严肃的行业（如金融）建议西装（男生配领带；女生不必）；互联网行业建议深色衬衫或T恤'
				},
				{
					title: '是否有好的和不好的头像案例对比？',
					description: '<img alt=\'简历头像配图\' src=\'https://files.wondercv.com/PC/cvs/photoexamples.png\' />'
				}
			]
    }
  },
  mounted() {
    let dom = document.querySelectorAll('.entry-wrapper .el-collapse-item__header')
    for (let i = 0; i < dom.length; i++) {
      let d = document.createElement('i');
      d.classList.add('iconfont', 'iconxiala')
      dom[i].appendChild(d);
    }
  },
  methods: {
    // 上传本地图片
    upImgTriggerFunc () {
      this.$refs.upImgInput.value = ''
      this.$refs.upImgInput.click()
    },
    // 监听图片
    upImgChangeFunc () {
      let file = this.$refs.upImgInput.files
      this.$emit('upImgChangeFunc', file)
    },
    // 手机上传图片
    upPhoneImgTriggerFunc () {
      this.$emit('upPhoneImgTriggerFunc')
    },
    collapseChangeFunc() {
      let dom = document.querySelectorAll('.entry-wrapper .el-collapse-item__arrow')
      for (let i = 0; i < dom.length; i++) {
        dom[i].classList.remove('el-icon-arrow-right')
        dom[i].classList.add('iconfont', 'iconxiala')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
</style>
